import React from "react";
import classnames from "classnames/bind";
import { observer } from "mobx-react";

import License from "./License";

import { useStore } from "../../../../../connect";

import styles from "../ProfileDropdown.scss";

const cx = classnames.bind(styles);

const LicensesList = () => {
  const { profile, locale } = useStore();

  return (
    !profile.payedServices.profileDropdownLicenses.isEmpty && (
      <span className={cx("licenses-list")}>
        {profile.payedServices.profileDropdownLicenses.list.map((license) => (
          <License key={license.serviceId} locale={locale} license={license} />
        ))}
      </span>
    )
  );
};

export default observer(LicensesList);
